import './NoticeChatting.css';
export default function NoticeChatting() {
	return <div id="NoticeChatting">Is chatting with someone!</div>;
}
